import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.ProductService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class ProductService extends RpcClass{

    /**
     *  @class ProductService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/ProductService.ProductService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param productIds {number[]} 
     * @param seasonId {string} 
     * @param subSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     addMultiProductsToSeasonAndSubSeason(productIds, seasonId, subSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/add-multi-products-to-season-and-sub-season', [productIds, seasonId, subSeasonId]);
    }
    /** 
     * @async
     * @param businessEntityId {string} 
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     afterInsertIdMapAddToEditableFieldLabelForExternalID(businessEntityId, clazzName) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/after-insert-id-map-add-to-editable-field-label-for-external-i-d', [businessEntityId, clazzName]);
    }
    /** 
     * @async
     * @param listOfSelectedProducts {module:src/server/com/silkplm/model/plm/Product.Product[]} 
     * @param listOfValueAttributes {module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     bulkEditDynamicAttributes(listOfSelectedProducts, listOfValueAttributes) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/bulk-edit-dynamic-attributes', [listOfSelectedProducts, listOfValueAttributes]);
    }
    /** 
     * @async
     * @param productId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     calculateOrderDetailsForProduct(productId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/calculate-order-details-for-product', [productId]);
    }
    /** 
     * @async
     * @param productId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     calculateProductInSeasonForProduct(productId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/calculate-product-in-season-for-product', [productId]);
    }
    /** 
     * @async
     * @param defaultEAN {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     checkIfEANIsUsedOnBudgetingPlannerPMOrOrderDetails(defaultEAN) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/check-if-e-a-n-is-used-on-budgeting-planner-p-m-or-order-details', [defaultEAN]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfMerchantsIsVisible() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/check-if-merchants-is-visible', []);
    }
    /** 
     * @async
     * @param wclProductId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     collectDataFromProductToBranding(wclProductId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/collect-data-from-product-to-branding', [wclProductId]);
    }
    /** 
     * @async
     * @param productWCLElement {module:src/server/com/silkplm/model/plm/ProductWCLElements.ProductWCLElements} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     collectDataFromProductToWclProduct(productWCLElement) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/collect-data-from-product-to-wcl-product', [productWCLElement]);
    }
    /** 
     * @async
     * @param productWCLElement {module:src/server/com/silkplm/model/plm/ProductWCLElements.ProductWCLElements} 
     * @param additionalTags {Object} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     collectDataFromProductToWclProduct(productWCLElement, additionalTags) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/collect-data-from-product-to-wcl-product', [productWCLElement, additionalTags]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @param categoryId {string} 
     * @param formNumberId {string} 
     * @param seasonId {string} 
     * @param countryOfOrigin {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     computeSkuForProductInSeasonForNaokoPathAfterClickButton(productInSeasonId, categoryId, formNumberId, seasonId, countryOfOrigin) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/compute-sku-for-product-in-season-for-naoko-path-after-click-button', [productInSeasonId, categoryId, formNumberId, seasonId, countryOfOrigin]);
    }
    /** 
     * @async
     * @param productAttributesId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Color.Color[]>}
     */
     findAllColorsForProductAttributes(productAttributesId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-all-colors-for-product-attributes', [productAttributesId]);
    }
    /** 
     * @async
     * @param productAttributesId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/IngredientWithValue.IngredientWithValue[]>}
     */
     findAllIngredientsForProductAttributes(productAttributesId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-all-ingredients-for-product-attributes', [productAttributesId]);
    }
    /** 
     * @async
     * @param productAttributesId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Material.Material[]>}
     */
     findAllMaterialsForProductAttributes(productAttributesId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-all-materials-for-product-attributes', [productAttributesId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/SubSeason.SubSeason[]>}
     */
     findAllSubSeasons() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-all-sub-seasons', []);
    }
    /** 
     * @async
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Currency.Currency>}
     */
     findCurrencyByNameRemote(name) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-currency-by-name-remote', [name]);
    }
    /** 
     * @async
     * @param productIdString {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Product.Product>}
     */
     findProductById(productIdString) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-product-by-id', [productIdString]);
    }
    /** 
     * @async
     * @param seasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     findRawProductsInSeason(seasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-raw-products-in-season', [seasonId]);
    }
    /** 
     * @async
     * @param technologicalId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/TechnologicalDetails.TechnologicalDetails[]>}
     */
     findTechnologicalDetails(technologicalId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/find-technological-details', [technologicalId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Product.Product[]>}
     */
     getAllProduct() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-all-product', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason[]>}
     */
     getAllProductInSeason() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-all-product-in-season', []);
    }
    /** 
     * @async
     * @param seasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason[]>}
     */
     getAllProductInSeasonForSeason(seasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-all-product-in-season-for-season', [seasonId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/ImageTag.ImageTag>}
     */
     getMainPictureTagOnMainPhotos() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-main-picture-tag-on-main-photos', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/ImageTag.ImageTag>}
     */
     getPPTag() {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-p-p-tag', []);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct[]>}
     */
     getPlanningTargetSupplier(productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-planning-target-supplier', [productInSeasonId]);
    }
    /** 
     * @async
     * @param productId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ProductAttributes.ProductAttributes>}
     */
     getProductAttributes(productId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/get-product-attributes', [productId]);
    }
    /** 
     * @async
     * @param listOfRow {module:src/server/org/apache/poi/ss/usermodel/Row.Row[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/plm/WarningAndBugs.WarningAndBugs>}
     */
     updateAsImportUnitsForProducts(listOfRow) {
            return RpcClass.rpcCall('/rpc/plm/services/product-service/update-as-import-units-for-products', [listOfRow]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.ProductService';
metadata.__type_short__ = 'ProductService';
ProductService.prototype.__metadata__ = metadata;

ProductService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/ProductService */
export default ProductService

export { ProductService }
